<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <UserNavigationSidebar :toggler.sync="isToggled" />
      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar :profile="getUserProfile" @toggled="toggleSidebarNav" />

      <!--     <Message class="alert-message" type="warning-alert" v-if="alertMessage">
        <p slot="alert-message" class="mb-0">{{ alertMessage }}</p>
      </Message> -->

      <section id="profile-content">
        <div class="card" style="min-height: calc(100vh - 150px); overflow: hidden">
          <div class="container-fluid">
            <div class="row d-flex">
              <div class="col-md-8">
                <PersonalInformationForm
                  :key="key"
                  @profileUpdated="forceRerender"
                  v-on:removeAlert="closeAlert()"
                ></PersonalInformationForm>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import Message from '@/components/AlertMessages/Message';
import TopNavbar from '@/components/Navigations/TopNavbar';
import UserNavigationSidebar from '@/components/Navigations/UserNavigationSidebar';
import PersonalInformationForm from '@/components/User/PersonalInformationForm';
/* import UploadImageForm from '@/components/User/UploadImageForm';
import AddDocuments from '@/components/User/AddDocuments'; */

export default {
  mixins: [toggleSidebarNav],
  components: {
    UserNavigationSidebar,
    PersonalInformationForm,
    /* UploadImageForm,
    AddDocuments, */
    TopNavbar,
    Message,
  },
  data: () => ({
    key: 0,
    alertMessage: '',
    isToggled: false,
  }),
  methods: {
    ...mapActions(['retrieveCandidateUserProfile']),
    forceRerender() {
      this.key += 1;
    },
    /* checkCompletedProfile() {
      const incompleteMessage = '';
      const completeMessage = '';

      const {
        first_name,
        last_name,
        languages,
        linkedin,
        email,
        competences,
      } = this.$store.getters.getUserProfile;

      const isCompletedProfile =
        first_name || last_name || languages || linkedin || email || competences;
    }, */
    closeAlert() {
      if (this.alertMessage) {
        this.alertMessage = '';
      }
    },
    setNotificationMessage() {
      if (localStorage.getItem('job_id')) {
        this.alertMessage =
          'Your application has been successfully submitted. In order for us to be able to propose other suitable job opportunities for you, we kindly ask you to update your profile page. It is very valuable for us if you add relevant skills that you have as tags below and if you have an updated traditional CV it can also be uploaded.';
      } else if (localStorage.getItem('job_id') === null) {
        this.alertMessage = '';
      }

      if (
        this.getUserProfile.completed === false &&
        this.getUserProfile.uncompleted_job_id === null
      ) {
        this.alertMessage =
          'Thanks for your registration. In order for us to be able to propose suitable job opportunities for you, we kindly ask you to update your profile page. It is very valuable for us if you add relevant skills that you have as tags below and if you have an updated traditional CV it can also be uploaded.';
      }

      if (this.$store.getters.getNotificationMessage) {
        this.alertMessage = this.$store.getters.getNotificationMessage;
      }
    },
  },
  computed: { ...mapGetters(['getUserProfile']) },
  mounted() {
    this.retrieveCandidateUserProfile().then(() => {
      this.setNotificationMessage();
    });
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_variables';

.guide-box {
  background-color: #fff;
  position: absolute;
  left: 112%;
  top: -150px;
  padding: 20px;
  width: 320px;
  z-index: 9999;
  border: 1px solid #ddd;
  border-radius: 12px;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.2);
  span {
    font-size: 18px;
    display: block;
    font-weight: 600;
    margin-bottom: 15px;
  }
  img {
    max-width: 100%;
    height: auto;
  }
  p {
    font-size: 14px;
  }
  .buttons {
    display: flex;
    gap: 15px;
    .btn {
      flex: 1;
      font-size: 13px;
    }
  }
}
#profile-content {
  .card {
    min-height: 625px;
    max-height: auto;
    padding: 15px 10px;
  }
  h1 {
    position: relative;
    display: inline-block;
    font-family: $font-family-sans-serif;
    font-weight: bolder;
    font-size: 21px;
    margin: 0;

    i {
      font-size: 18px;
      position: relative;
      top: -2.5px;
      color: #888;
    }
  }

  .profile-info {
    li {
      margin-bottom: 20px;
      font-family: $font-family-sans-lato;
      font-size: 14px;

      div {
        &.d-flex {
          border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
          margin: 3px 0px;
          padding: 12px 0;
          height: 46px;
        }
      }
    }
    .edit-label {
      display: inline-block;
      min-width: 90px;
      font-size: 14px;
      font-weight: 700;
      margin-right: 12px;
    }
  }
}

.alert-message {
  margin: 12px 25px;
}

@media only screen and (max-width: 1251px) {
  .card {
    border-top-left-radius: 18px !important;
    border-top-right-radius: 18px !important;
    margin: 24px 23px 0 23px !important;
  }
  .col-md-8 {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .alert-message {
    margin: 40px 25px 12px 25px;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    border-top-left-radius: 18px !important;
    border-top-right-radius: 18px !important;
    margin: 24px 0 0 0 !important;
  }
  .alert-message {
    margin: 40px 0px 12px 0px;
  }
}

@media only screen and (max-width: 768px) {
}

@media only screen and (max-width: 576px) {
  .card {
    margin: 0 !important;
    overflow: auto !important;
    min-height: 100% !important;
    height: 100vh !important;
    .add-document {
      .err-msg {
        text-align: center;
      }
    }
  }
  #profile-content {
    .profile-info {
      li {
        margin: 3px 20px;
      }
    }
  }
}
</style>
